import { composeIO } from 'react-compose-io'
import { graficoBarrasIO } from './GraficoBarras.IO'
import { GraficoBarrasView } from './GraficoBarras.View'

export const GraficoBarras = composeIO(GraficoBarrasView, graficoBarrasIO)
